(() => {
    if (window.dmMenuOverlayKeyboardReady) return;
    window.dmMenuOverlayKeyboardReady = true;

    const MENU_TRANSITION_DELAY = 450;
    const overlayQuery = window.matchMedia('(max-width: 1024px)');
    let menuTrigger = null;
    let focusTimer = null;
    let closeTimer = null;

    const getPanel = () => document.getElementById('dm-sidebar-desktop-menu');
    const getTrigger = () => menuTrigger || document.querySelector('[data-mobile-menu]');
    const isOpen = () => overlayQuery.matches && document.body.classList.contains('sidebar-menu-open');

    const syncPanelState = () => {
        const panel = getPanel();
        if (!panel) return;

        if (overlayQuery.matches) {
            panel.toggleAttribute('inert', !isOpen());
        } else {
            panel.removeAttribute('inert');
        }
    };

    const scheduleTrap = () => {
        window.clearTimeout(focusTimer);
        focusTimer = window.setTimeout(() => {
            const panel = getPanel();
            if (!panel || !isOpen()) return;

            const hiddenFocusables = Array.from(panel.querySelectorAll(
                "a[href], button:enabled, [tabindex]:not([tabindex^='-']), input:not([type=hidden]):enabled, select:enabled, textarea:enabled"
            )).filter((element) => element.getClientRects().length === 0);
            const previousStates = hiddenFocusables.map((element) => ({
                element,
                disabled: 'disabled' in element ? element.disabled : null,
                href: element.getAttribute('href'),
                tabindex: element.getAttribute('tabindex')
            }));

            hiddenFocusables.forEach((element) => {
                if ('disabled' in element) element.disabled = true;
                if (element.matches('a[href]')) element.removeAttribute('href');
                if (element.hasAttribute('tabindex')) element.setAttribute('tabindex', '-1');
            });
            trapFocus(panel, panel.querySelector('[data-dm-menu-close]'));
            previousStates.forEach(({ element, disabled, href, tabindex }) => {
                if (disabled !== null) element.disabled = disabled;
                if (href !== null) element.setAttribute('href', href);
                if (tabindex !== null) element.setAttribute('tabindex', tabindex);
            });
        }, MENU_TRANSITION_DELAY);
    };

    const scheduleClose = () => {
        const panel = getPanel();
        const trigger = getTrigger();

        window.clearTimeout(focusTimer);
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
            document.body.classList.remove('sidebar-menu-open', 'menu_open');
            panel?.setAttribute('aria-hidden', 'true');
            document.querySelectorAll('[data-open-menu-hamburguer-sidebar], [data-mobile-menu]').forEach((button) => {
                button.setAttribute('aria-expanded', 'false');
            });
            removeTrapFocus(trigger);
            panel?.setAttribute('inert', '');
        }, 0);
    };

    window.addEventListener('click', (event) => {
        const trigger = event.target.closest?.('[data-mobile-menu]');

        if (trigger && !trigger.closest('#dm-sidebar-desktop-menu')) {
            if (!overlayQuery.matches) return;

            menuTrigger = trigger;
            getPanel()?.removeAttribute('inert');
            scheduleTrap();
            return;
        }

        if (!isOpen()) return;

        if (event.target.closest?.('#dm-sidebar-desktop-menu [data-dm-menu-close]')
            || event.target.classList.contains('background-overlay')) {
            event.preventDefault();
            event.stopPropagation();
            scheduleClose();
        }
    }, true);

    window.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !isOpen()) return;

        event.preventDefault();
        event.stopPropagation();
        scheduleClose();
    }, true);

    overlayQuery.addEventListener('change', () => {
        window.clearTimeout(focusTimer);
        if (!overlayQuery.matches) removeTrapFocus();
        syncPanelState();
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncPanelState, { once: true });
    } else {
        syncPanelState();
    }
})();
